import React, { useState, useEffect, useRef } from 'react';
// import { useHistory } from 'react-router-dom';
import { getpofinancetrackerlistFromServer, getpofinancetrackerbyidFromServer } from '../../services/pofinancetracker';
// import { HttpClient } from '../common/httpClient';

import $ from 'jquery';
import axios from 'axios';
import { getUploadedFileNativePath } from '../../services/common/credentials';
import { AgGridReact } from 'ag-grid-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Select } from 'semantic-ui-react';

const P2PTrackerComponent = () => {
  // const history = useHistory();
  const [userdtl, setUserdtl] = useState();
  const [user, setUser] = useState();
  const [cardTitle, setCardTitle] = useState("Po Finance Tracker");
  const [objporeq, setObjporeq] = useState();
  const [boolPoreqList, setBoolPoreqList] = useState(false);
  const [porequirementlist, setPorequirementlist] = useState();
  const [porequirementdetail, setPorequirementdetail] = useState();
  const [porequirmentDetails, setPorequirmentDetails] = useState();
  const [editporequirement, setEditporequirement] = useState();
  const [editporeq, setEditporeq] = useState();
  const [show, setshow] = useState(false);
  const [show1, setshow1] = useState(true);
  const [porequirmenttab, setPorequirmenttab] = useState();
  const [comment, setComment] = useState();
  const [poquotation, setpoquotation] = useState();
  const [fileupload, setFileUpload] = useState();
  const [financeresponse, setFinanceresponse] = useState();
  const [paginationsize, setpaginationsize] = useState(25);
  const [rowData, setrowData] = useState(null);
  const [unapprovedlist, setunapprovedlist] = useState(null);
  const [approvedlist, setapprovedlist] = useState(null);
  const [listval, setListval] = useState('Unapproved List');

  const Unapproved = () => {
    setrowData(unapprovedlist);
    setListval('Unapproved List');
  };

  const approved = () => {
    setrowData(approvedlist);
    setListval('approved List');
  };

  const revertClick = () => {
    // Implement the functionality for the revert button here
    console.log('Revert button clicked!');
  };

  const approveorder = (action) => {
    // Implement the functionality for the approve, hold, and reject buttons here
    console.log('Action:', action);
  };

  const fileInput = useRef(null);

  const handleClose = () => {
    setshow(false);
  }

  const handleSubmit = () => {
    setshow(false);
  }

  const displayTable = () => {
    setshow1(false);
  }
  const displayModel = () => {
    setshow(true);
    setBoolPoreqList(true);
  }

  useEffect(() => {
    setUserdtl(JSON.parse(localStorage.getItem('useracess')));
    setUser(JSON.parse(localStorage.getItem('Userdtl')));
    setComment("");
    getporequirementlist();
  }, []);



  // const approveorder = (i) => {
  //   const Indata = {
  //     tenant_id: userdtl.tenant_id,
  //     entity_id: userdtl.entity_id,
  //     group_id: userdtl.group_id,
  //     module_id: userdtl.module_id,
  //     user_id: user.user_id,
  //     requirement_id: objporeq.requirement_id,
  //     is_finance_approved: i,
  //     remarks: comment
  //   };

  //   var getFileUploadsList = postapprovalPRFFromServer();

  //   axios.get(getFileUploadsList[1], { params: Indata }, getFileUploadsList[0])
  //     .then((recieveddata) => {
  //       const tempresponsedata = recieveddata;
  //       console.log("porequirementlist---", tempresponsedata);
  //       setFinanceresponse(tempresponsedata);
  //     });

  //   if (financeresponse.Status === "Success") {
  //     if (i === 1) {
  //       alert("PRF no:" + objporeq.prf_number + "Approved Sucessfully");
  //       list();
  //     } else if (i === 2) {
  //       alert("PRF no:" + objporeq.prf_number + "Holded Sucessfully");
  //       list();
  //     } else if (i === 3) {
  //       alert("PRF no:" + objporeq.prf_number + "Rejected Sucessfully");
  //       list();
  //     }
  //   }
  //   setComment("");
  //   $("#modal_approval").modal("hide");
  // };

  const closemodel = () => {
    $("#modal_approval").modal("hide");
  };

  const list = () => {
    setBoolPoreqList(false);
    getporequirementlist();
  };

  const getporequirementlist = () => {
    const Indata = {
      tenant_id: 1,
      entity_id: 1,
      group_id: 1,
      module_id: 1,
      user_id: 37,
    };
    console.log("inputporequirementlist", Indata);
    var getFileUploadsList = getpofinancetrackerlistFromServer();

    axios.post(getFileUploadsList[1], Indata, getFileUploadsList[0])
      .then((recieveddata) => {
        const tempresponsedata = recieveddata;
        let data = tempresponsedata?.data;
        console.log("porequirementlist---", tempresponsedata);
        setPorequirementlist(tempresponsedata);
        setPorequirementdetail(tempresponsedata.data);
        setunapprovedlist(data?.data)
        setapprovedlist(data?.approved_list)
        setrowData(data?.data);

      });
  };



  const ShowPorequirementdetail = (data) => {
    console.log('dataaaa', data.data);
    let data1 = data.data;
    const objporeq = {
      requirement_id: data1.requirement_id,
      tenant_id: 1,
      entity_id: 1,
      group_id: 1,
      module_id: 1,
      user_id: 37
    };
    console.log("EDITinputporequirement", objporeq);
    var getFileUploadsList = getpofinancetrackerbyidFromServer();

    axios.post(getFileUploadsList[1], objporeq, getFileUploadsList[0])
      .then((recieveddata) => {
        const tempresponsedata = recieveddata.data;
        const finaldata = tempresponsedata.po_requirement;
        console.log("prfeditresponse---", tempresponsedata);
        setEditporequirement(tempresponsedata);
        setEditporeq(tempresponsedata.po_requirement);
        console.log('finaldata', finaldata);
        const poreq = finaldata?.prf_list;
        const porequirmentDetails = finaldata?.requirement_info;
        const porequirmenttab = finaldata?.poquotation;

        setPorequirmentDetails(porequirmentDetails);
        setPorequirmenttab(porequirmenttab);

        console.log("prfreqinfo---", porequirmentDetails);
        console.log("poquotation---", porequirmenttab);
        console.log("poreq---", poreq);

        setObjporeq({

          requirement_id: poreq[0].requirement_id,
          requirement_date: poreq[0].requirement_date,
          reporting_manager: poreq[0].reporting_manager,
          purpose: poreq[0].purpose,
          purchase_type: poreq[0].purchase_type,
          purchase_catagory: poreq[0].purchase_catagory,
          prf_number: poreq[0].prf_number,
          perceived_benefits: poreq[0].perceived_benefits,
          location: poreq[0].location,
          is_budgeted: poreq[0].is_budgeted,
          finalized_vendor: poreq[0].finalized_vendor,
          department: poreq[0].department,
          date_of_delivery_expected: poreq[0].date_of_delivery_expected,
          budget_allocated: poreq[0].budget_allocated,
          delivery_address: poreq[0].delivery_address,
          payment_term: poreq[0].payment_term,
          total_line_value: poreq[0].total_line_value,
          vendor_selection_reason: poreq[0].vendor_selection_reason,
          approver_mailid: poreq[0].approver_mailid,
          approver_name: poreq[0].approver_name,
          approver_department: poreq[0].approver_department,
          VendorFile_name: poreq[0].VendorFile_name,
          is_processed: poreq[0].is_processed,
          po_file_name: poreq[0].po_file_name,
          SupportFile_name: poreq[0].SupportFile_name,
          is_finance_approved: poreq[0].is_finance_approved,
          is_p2p_approved: poreq[0].is_p2p_approved,
          finance_approver: poreq[0].finance_approver,
          po_number: poreq[0].po_number,
        });

        setpoquotation({
          vendor_type: porequirmenttab[0].vendor_type,
          vendor_name: porequirmenttab[0].vendor_name,
          vendor_code: porequirmenttab[0].vendor_code,
          vendor_location: porequirmenttab[0].vendor_location,
          vendor_address: porequirmenttab[0].vendor_address,
          gst_number: porequirmenttab[0].gst_number,
          vendor_emailid: porequirmenttab[0].vendor_emailid,
          quotationfile_name: porequirmenttab[0].quotationfile_name,
        }
        );

        setBoolPoreqList(true);
      });
  };



  const handleSelectChange = (e, { value }) => {

    console.log('Selected value:', value);
    setpaginationsize(value);
  };

  const options = [
    { text: '10', value: 10 },
    { text: '25', value: 25 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },

  ];

  var gridColumns = [

    { field: 'prf_number', headerName: 'PRF Number', sortable: true, filter: true, resizable: true },
    { field: 'requirement_date', headerName: 'Requirement Date', sortable: true, filter: true, resizable: true },
    { field: 'department', headerName: 'Department', sortable: true, filter: true, resizable: true },
    { field: 'purpose', headerName: 'Purpose', sortable: true, filter: true, resizable: true },
    { field: 'purchase_catagory', headerName: 'PurchaseCategory', sortable: true, filter: true, resizable: true },
    // { field: 'po_status', headerName: 'Status', sortable: true, filter: true, resizable: true },
    // { field: 'Comments', headerName: 'Comments', sortable: true, filter: true, resizable: true },
    {
      headerName: 'Edit',
      cellRendererFramework: (params) => (
        <button
          onClick={() => ShowPorequirementdetail(params)}
          className="edit-button"
        >
          <i className="fa fa-edit" aria-hidden="true"></i>
        </button>
      ),
      width: 80,
    },

  ]

  const QuotationTabs = ({ quotations }) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
      setActiveTab(index);
    };

    return (
      <div>
        {quotations?.map((quotation, index) => (
          <div key={quotation.pobudget_id}>
            <a onClick={() => handleTabClick(index)}>
              Quotation {index + 1}
            </a>
            <div className="tab-content" hidden={activeTab !== index}>
              <div className="tab-pane active show" id={`poquotation_${index}`}>

                <div className="row">

                  <div className="form-group col-md-4 mb-2">

                    <table>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Type</label>
                        </th>
                        <th className="pad-14"> {quotation?.vendor_type}</th>
                      </tr>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Name</label>
                        </th>
                        <th className="pad-14"> {quotation?.vendor_name} </th>
                      </tr>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Code</label>
                        </th>
                        <th className="pad-14"> {quotation?.vendor_code}</th>
                      </tr>
                    </table>

                  </div>
                  <div className="form-group col-md-4 mb-2">
                    <table>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Location</label>
                        </th>
                        <th className="pad-14">{quotation?.vendor_location} </th>
                      </tr>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Address</label>
                        </th>
                        <th className="pad-14"> {quotation?.vendor_address} </th>
                      </tr>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor GST Number</label>
                        </th>
                        <th className="pad-14"> {quotation?.gst_number} </th>
                      </tr>
                    </table>
                  </div>
                  <div className="form-group col-md-4 mb-2">
                    <table>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Vendor Email ID</label>
                        </th>
                        <th className="pad-14"> {quotation?.vendor_emailid}</th>
                      </tr>
                      <tr className="pad-14">
                        <th className="pad-14">
                          <label htmlFor="userinput2">Quotation Doc</label>
                        </th>
                        <th className="pad-14">
                          <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                            {quotation?.quotationfile_name}
                          </a>
                        </th>
                      </tr>
                    </table>
                  </div>
                  </div>
                  <div className="row pad-14">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr className="bg-light-gray2">
                          <th className="th-sm"> Material/Service Name </th>
                          <th className="th-sm"> Description </th>
                          <th className="th-sm"> Quantity </th>
                          <th className="th-sm"> Approx Unit Value </th>
                          <th className="th-sm"> Approx Total Value </th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotation.quotation.map((quotationItem) => (
                          <tr key={quotationItem.pobudgetinfo_id}>
                            <td>{quotationItem.vendor_material_name}</td>
                            <td>{quotationItem.vendor_line_description}</td>
                            <td>{quotationItem.vendor_quantity}</td>
                            <td>{quotationItem.vendor_unit_value}</td>
                            <td>{quotationItem.vendor_total_value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        ))}
          </div>
        );
  };

        // Rest of the code...

        return (
        <>
          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid">
                <div className="block-header">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item bcrumb-1">
                          <a href="../../Dashboard">
                            <i className="fa fa-home"></i> Home
                          </a>
                        </li>
                        <li className="breadcrumb-item active">p2p Team Approval</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card1">
                      <form>
                        <div>
                          <h4 className="header d-flex justify-content-between">
                            {cardTitle}
                            <div hidden={!boolPoreqList} onClick={list}>
                              Back <i className="fa fa-hand-o-right"></i>
                            </div>
                          </h4>



                          <div hidden={!boolPoreqList}>
                            <div className="row">

                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">PRF No</label>
                                    </th>
                                    <th>{objporeq?.prf_number}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Requirement Date</label>
                                    </th>
                                    <th> {objporeq?.requirement_date}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Department</label>
                                    </th>
                                    <th> {objporeq?.department}</th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Reporting Manager</label>
                                    </th>
                                    <th> {objporeq?.reporting_manager}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Purpose</label>
                                    </th>
                                    <th> {objporeq?.purpose}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Purchase Category</label>
                                    </th>
                                    <th> {objporeq?.purchase_catagory}</th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Type of Purchase</label>
                                    </th>
                                    <th> {objporeq?.purchase_catagory}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Location</label>
                                    </th>
                                    <th> {objporeq?.location}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Budgeted</label>
                                    </th>
                                    <th> {objporeq?.is_budgeted}</th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Date of Delivery Expected</label>
                                    </th>
                                    <th> {objporeq?.date_of_delivery_expected}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Delivery Address</label>
                                    </th>
                                    <th> {objporeq?.delivery_address}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Requirement Total</label>
                                    </th>
                                    <th> {objporeq?.budget_allocated}</th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">PaymentTerm</label>
                                    </th>
                                    <th>{objporeq?.payment_term} </th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">perceived Benefits</label>
                                    </th>
                                    <th>{objporeq?.perceived_benefits} </th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Finalized Vendor</label>
                                    </th>
                                    <th>{objporeq?.finalized_vendor} </th>

                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Approver Email ID</label>
                                    </th>
                                    <th> {objporeq?.approver_mailid}</th>
                                  </tr>

                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Approver name</label>
                                    </th>
                                    <th> {objporeq?.approver_name}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Approver Department</label>
                                    </th>
                                    <th> {objporeq?.approver_department}</th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">PO Doc</label>
                                    </th>
                                    <th>
                                      <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/PO07688_Team_Computers_Pvt_Ltd__Delhi_2021_07_13_14_46_41_447511.pdf">
                                        {objporeq?.po_file_name}
                                      </a>
                                    </th>
                                  </tr>

                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Supporting Doc</label>
                                    </th>
                                    <th>
                                      <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
                                        {objporeq?.SupportFile_name}
                                      </a>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Doc</label>
                                    </th>
                                    <th>
                                      <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
                                        {objporeq?.VendorFile_name}
                                      </a>
                                    </th>
                                  </tr>
                                </table>


                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr>
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">PO Number</label>
                                    </th>
                                    <th> {objporeq?.po_number}</th>
                                  </tr>
                                  <tr>
                                    <th className="pad-14">

                                      <a onClick={displayModel}><i className="fa fa-check-square-o"></i> Quotations</a>

                                    </th>
                                  </tr>
                                </table>
                              </div>

                            </div>

                            <div className="row pad-14">

                              {/* {porequirmentDetails?.map((poqutation) => ( */}
                              <table className="table table-striped table-bordered" >
                                <thead>
                                  <tr className="bg-light-gray2">
                                    <th className="th-sm"> Material/Service Name </th>
                                    <th className="th-sm"> Description </th>
                                    <th className="th-sm"> Budget Category </th>
                                    <th className="th-sm"> Quantity </th>
                                    <th className="th-sm"> Approx Unit Value </th>
                                    <th className="th-sm"> Approx Total Value </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {porequirmentDetails?.map((quotationItem) => (
                                    <tr key={quotationItem.pobudgetinfo_id}>
                                      <td>{quotationItem.material_name}</td>
                                      <td>{quotationItem.line_description}</td>
                                      <td>{quotationItem.budget_category}</td>
                                      <td>{quotationItem.quantity}</td>
                                      <td>{quotationItem.unit_value}</td>
                                      <td>{quotationItem.total_value}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              {/* ))} */}


                            </div>

                            <div className="row">
                              <QuotationTabs quotations={porequirmenttab} />

                              {/* <a onClick={displayTable}>
                                Quotation1
                              </a>

                              <div className="tab-content" hidden={show1}>
                                <div className="tab-pane active show" id="poqutation_0">
                                  <div className="row">

                                    <div className="form-group col-md-4 mb-2">

                                      <table>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Type</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.vendor_type}</th>
                                        </tr>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Name</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.vendor_name} </th>
                                        </tr>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Code</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.vendor_code}</th>
                                        </tr>
                                      </table>

                                    </div>
                                    <div className="form-group col-md-4 mb-2">
                                      <table>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Location</label>
                                          </th>
                                          <th className="pad-14">{poquotation?.vendor_location} </th>
                                        </tr>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Address</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.vendor_address} </th>
                                        </tr>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor GST Number</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.gst_number} </th>
                                        </tr>
                                      </table>
                                    </div>
                                    <div className="form-group col-md-4 mb-2">
                                      <table>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Vendor Email ID</label>
                                          </th>
                                          <th className="pad-14"> {poquotation?.vendor_emailid}</th>
                                        </tr>
                                        <tr className="pad-14">
                                          <th className="pad-14">
                                            <label htmlFor="userinput2">Quotation Doc</label>
                                          </th>
                                          <th className="pad-14">
                                            <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                                              {poquotation?.quotationfile_name}
                                            </a>
                                          </th>
                                        </tr>
                                      </table>
                                    </div>

                                  </div>
                                  <div className="row pad-14">
                                    {porequirmenttab?.map((poqutation) => (
                                      <table className="table table-striped table-bordered" key={poqutation.pobudget_id}>
                                        <thead>
                                          <tr className="bg-light-gray2">
                                            <th className="th-sm"> Material/Service Name </th>
                                            <th className="th-sm"> Description </th>
                                            <th className="th-sm"> Budget Category </th>
                                            <th className="th-sm"> Quantity </th>
                                            <th className="th-sm"> Approx Unit Value </th>
                                            <th className="th-sm"> Approx Total Value </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {poqutation.quotation.map((quotationItem) => (
                                            <tr key={quotationItem.pobudgetinfo_id}>
                                              <td>{quotationItem.vendor_material_name}</td>
                                              <td>{quotationItem.vendor_line_description}</td>
                                              <td>{quotationItem.budget_category}</td>
                                              <td>{quotationItem.vendor_quantity}</td>
                                              <td>{quotationItem.vendor_unit_value}</td>
                                              <td>{quotationItem.vendor_total_value}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ))}
                                  </div>
                                </div>
                              </div> */}
                            </div>

                            {/* <div className="row">
                          <div className="form-group col-md-4 mb-2">

                            
                            <div>
                              {listval == 'approved List' ? (
                                <><p>Finance Approver</p><p>{objporeq?.finance_approver}</p></>
                              ) :
                                (<select
                                  className="custom-select form-control ng-pristine ng-invalid ng-touched"
                                  data-validation-required-message="This Finance Approver required"
                                  id="finance_approver"
                                  name="finance_approver"
                                  required
                                  tabIndex="5"
                                >
                                  <option value="">Select Finance Approver</option>

                                  {true ? <option value="Vikram">Vikram</option> : null}
                                </select>)}

                            </div>
                          </div>
                          <div className="form-group col-md-4 mb-2">
                            {true ? (
                              <div>
                                <label htmlFor="userinput2">PO Doc upload</label>
                                {listval == 'approved List' ? (<p>{objporeq?.po_file_name}</p>) : (<input id="myfile" name="myfile" type="file" />)}

                              </div>
                            ) : null}
                          </div>
                          <div className="form-group col-md-4 mb-2">
                            {true ? (
                              <div>
                                <label htmlFor="userinput2">PO Number</label>
                                <input
                                  id="po_number"
                                  name="po_number"
                                  required
                                  type="text"
                                  className="ng-untouched ng-pristine ng-invalid"
                                />
                              </div>
                            ) : null}
                          </div>
                          <div className="form-group col-md-4 mb-2"></div>
                        </div> */}

                            {/* <>

                          {objporeq?.is_finance_approved === 1 && (
                            <div className="row mt-20">
                              <div className="form-group col-md-4 mb-2">
                                <div className="text-right">
                                  <button
                                    type="submit"
                                    className="btn btn-raised btn-primary btn-min-width mr-1"
                                    onClick={revertClick}
                                  >
                                    <i className="fa fa-check-square-o"></i> Revert
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}


                          <div className="row mt-5">
                            {objporeq?.is_p2p_approved !== 1 && (
                              <div className="form-group col-md-6 mb-2">
                                <label htmlFor="userinput1">Remarks</label>
                                <textarea
                                  className="form-control bg-transparent"
                                  value={comment}
                                  onChange={(e) => setComment(e.target.value)}
                                  name="comment"
                                  id="comment"
                                  maxLength="500"
                                ></textarea>
                              </div>
                            )}
                          </div>


                          <div className="row mt-20">
                            {listval === 'Unapproved List' && (
                              <>
                                <div className="form-group col-md-4 mb-2">
                                  <div className="text-right">
                                    <button
                                      type="submit"
                                      className="btn btn-raised btn-primary btn-min-width mr-1"
                                      onClick={() => approveorder(1)}
                                    >
                                      <i className="fa fa-check-square-o"></i> Approve
                                    </button>
                                  </div>
                                </div>
                                <div className="form-group col-md-4 mb-2">
                                  <div className="text-center">
                                    <button
                                      type="submit"
                                      className="btn btn-raised btn-primary btn-min-width mr-1"
                                      onClick={() => approveorder(2)}
                                    >
                                      <i className="fa fa-check-square-o"></i> Hold
                                    </button>
                                  </div>
                                </div>
                                <div className="form-group col-md-4 mb-2">
                                  <div className="text-left">
                                    <button
                                      type="submit"
                                      className="btn btn-raised btn-primary btn-min-width mr-1"
                                      onClick={() => approveorder(3)}
                                    >
                                      <i className="fa fa-check-square-o"></i> Reject
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </> */}



                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>



            <div className="report" hidden={boolPoreqList}>
              <p>{listval}</p>
              <div className='row'>
                <div className='col-md-8'>
                  <Select
                    options={options}
                    placeholder="Select an option"
                    defaultValue={25}
                    onChange={handleSelectChange}
                  />
                </div>
                <div className='col-md-3'>
                  <Button onClick={approved}>Approved List</Button>
                  <Button style={{ marginLeft: '1em' }} onClick={Unapproved}>UnApproved List</Button>
                </div>
              </div>
              <div className="ag-theme-balham report-layer" style={{ width: '100%', heidght: '100%' }}>
                <AgGridReact
                  columnDefs={gridColumns}
                  rowData={rowData}
                  paginationPageSize={paginationsize}
                  pagination={true}
                  animateRows={true}
                  rowSelection={'multiple'}
                  groupSelectsChildren={true}

                  suppressAggAtRootLevel={true}
                  suppressRowClickSelection={true}

                >
                </AgGridReact>
              </div>
            </div>

            <Modal
              show={show}
              size="lg"
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Quotation Comparison</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group col-md-12">
                  <table>
                    <tr>
                      <th className="pad-14">
                        <label htmlFor="userinput2">Vendor Name</label>
                      </th>
                      <th className="pad-14"> {poquotation?.vendor_name} </th>
                    </tr>
                  </table>
                </div>
                <div className="form-group col-md-12">
                  <table>
                    <tr>
                      <th className="pad-14">
                        <label htmlFor="userinput2">Quotation Doc</label>
                      </th>
                      <th className="pad-14">
                        <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                          {poquotation?.quotationfile_name}
                        </a>
                      </th>
                    </tr>
                  </table>
                </div>

                <div className="row pad-14">
                  {porequirmenttab?.map((poqutation) => (
                    <table className="table table-striped table-bordered" key={poqutation.pobudget_id}>
                      <thead>
                        <tr className="bg-light-gray2">
                          <th className="th-sm"> Material/Service Name </th>
                          <th className="th-sm"> Description </th>
                          <th className="th-sm"> Budget Category </th>
                          <th className="th-sm"> Quantity </th>
                          <th className="th-sm"> Approx Unit Value </th>
                          <th className="th-sm"> Approx Total Value </th>
                        </tr>
                      </thead>
                      <tbody>
                        {poqutation.quotation.map((quotationItem) => (
                          <tr key={quotationItem.pobudgetinfo_id}>
                            <td>{quotationItem.vendor_material_name}</td>
                            <td>{quotationItem.vendor_line_description}</td>
                            <td>{quotationItem.budget_category}</td>
                            <td>{quotationItem.vendor_quantity}</td>
                            <td>{quotationItem.vendor_unit_value}</td>
                            <td>{quotationItem.vendor_total_value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ))}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={handleClose}>
                  Close
                </Button>

              </Modal.Footer>
            </Modal>

          </div>
        </>
        );

};

        export default P2PTrackerComponent;